import { TimeSlotContainer } from './components/time-slots/time-slot-container';
import React, { useEffect, useMemo, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { LecturerRatesVersions } from '../../../../api/types/lecturers/price-rate/lecturer-rate-res';
import { LecturerType } from '../../../../api/types/programs/course/lecturers/course-lecturer';
import globalCourseStore from '../../../../stores/global-course-store';
import { LecturerRatesById } from '../../../../api/types/lecturers/user-details-lecturer';
import globalConfigStore from '../../../../stores/global-config-store';
import appApi from '../../../../api/app-api';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { SelectedSlotsState } from './components/time-slots/types/selected-slots';
import { AvailabilitySlot } from '../../../../api/types/calender/avalability-slots/availability-slot';
import globalProgramStore from '../../../../stores/program-store';
import { toast } from 'react-toastify';
import { ScheduleType } from '../../create-calendar-schedule-dialog';
import { InputSwitch } from 'primereact/inputswitch';
import globalSettingsStores from '../../../../stores/settings-stores';
import { Tooltip } from 'primereact/tooltip';
import { ManualTimeCalendar } from './components/manual-time-calendar';
import { Checkbox } from 'primereact/checkbox';

export type LecturerWithActivityId = LecturerType & {
  activityType: LecturerRatesVersions | null;
};

export type LecturerIdWithActivityTypeId = {
  lecturerId: number;
  activityTypeId: number | undefined;
};

interface CreateLectureSerialTabDatamodel {
  branchId: number;
  supportMultiple: boolean;
  timeSlot:
    | {
        start: Date;
        end: Date;
        classId: number;
      }
    | null
    | undefined;
  onApprove: (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide: () => any,
    attendanceRequired: boolean,
    lectureAttendanceSessionNumber: number,
    lectureBreakMinutes?: number,
    professorRetroactiveWorkingHours?: boolean,
  ) => any;
  onHide: () => any;
  scheduleType: ScheduleType;
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  };
  allowRetroactiveWorkingHoursSupport?: boolean;
  /** When false, locks the attendance-segments dropdown */
  allowEditAttedancePartialNumber?: boolean;
  /** When false, locks the add-break checkbox */
  allowEditBreakMinutes?: boolean;
  /** Optional default for the attendance-segments dropdown */
  studentAttendacePartialNumber?: number;
  editMode?: boolean;
}
export const CreateLectureSerialTab: React.FC<
  CreateLectureSerialTabDatamodel
> = ({
  branchId,
  supportMultiple,
  timeSlot,
  onApprove,
  onHide,
  scheduleType,
  editTimeSlot,
  allowRetroactiveWorkingHoursSupport = false,
  allowEditAttedancePartialNumber = true,
  allowEditBreakMinutes = true,
  studentAttendacePartialNumber,
  editMode = false,
}) => {
  const [selectedLectures, setSelectedLectures] = useState<
    LecturerWithActivityId[] | null
  >(null);

  const [attendanceRequire, setAttendanceRequire] = useState(true);
  const [lectureAttendanceSessionNumber, setLectureAttendanceSessionNumber] =
    useState<number>(studentAttendacePartialNumber ?? 1);
  const [addBreak, setAddBreak] = useState<boolean>(false);
  const [lectureBreakMinutes, setLectureBreakMinutes] = useState<number | null>(
    null,
  );
  const [
    professorRetroactiveWorkingHours,
    setProfessorRetroactiveWorkingHours,
  ] = useState<boolean>(false);

  const courseLectures = useMemo(() => {
    return globalCourseStore.getCurrentCourse()?.details?.lecturer || [];
  }, [globalCourseStore]);

  const [lecturerRateById, setLecturerRateById] =
    useState<LecturerRatesById | null>(null);

  const [startDate, setStartDate] = useState<Date | null>(
    timeSlot?.start ?? null,
  );

  const vacationRanges = useMemo(() => {
    return (globalSettingsStores.calendarVacations || []).map((v) => {
      const start = v.startDate ? new Date(v.startDate as any) : null;
      const end = v.endDate ? new Date(v.endDate as any) : null;

      return {
        id: v.id,
        title: v.title,
        start: start && !Number.isNaN(start.getTime()) ? start : null,
        end: end && !Number.isNaN(end.getTime()) ? end : null,
      };
    });
  }, [globalSettingsStores.calendarVacations]);

  const isVacationDate = (
    date: Date,
  ): { isVacation: boolean; title?: string } => {
    const normalized = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0,
    );

    for (const v of vacationRanges) {
      if (!v.start && !v.end) continue;

      const start = v.start
        ? new Date(v.start.getFullYear(), v.start.getMonth(), v.start.getDate())
        : null;
      const end = v.end
        ? new Date(v.end.getFullYear(), v.end.getMonth(), v.end.getDate())
        : null;

      if (start && end) {
        if (normalized >= start && normalized <= end) {
          return { isVacation: true, title: v.title };
        }
      } else if (start) {
        if (normalized.getTime() === start.getTime()) {
          return { isVacation: true, title: v.title };
        }
      } else if (end) {
        if (normalized.getTime() === end.getTime()) {
          return { isVacation: true, title: v.title };
        }
      }
    }

    return { isVacation: false };
  };

  const handleDateChange = (e: any) => {
    if (e.target.value instanceof Date || e.target.value === null) {
      setStartDate(e.target.value);
    }
  };

  const [startTime, setStartTime] = useState<Date | null>(timeSlot?.start);
  const [endTime, setEndTime] = useState<Date | null>(timeSlot?.end);

  const [numberOfIterations, setNumberOfIterations] = useState(1);

  const [isLoadingCreateLectures, setIsLoadingCreateLectures] = useState(false);

  useEffect(() => {
    const logic = async () => {
      const userIds: number[] = selectedLectures?.map((item) => item.id);
      console.log(`XXXXX userIds: ${userIds}`);

      //const branch = globalConfigStore.rootFilter.currentBranches;
      if (branchId) {
        const lecturerPaymentRateRes =
          await appApi.getUserLecturerPaymentRateByBranchId(userIds, branchId);

        const lecturerPaymentRate = lecturerPaymentRateRes.data.body;
        setLecturerRateById(lecturerPaymentRate);
        console.log(`XXXXX userIds: ${JSON.stringify(lecturerPaymentRate)}`);
      }
    };

    if (selectedLectures && selectedLectures.length > 0) {
      logic();
    }
  }, [selectedLectures]);

  const handleSelectedActivityTypeForLecturer = (
    lecturer: LecturerType,
    selectedActivityType: LecturerRatesVersions,
  ) => {
    setSelectedLectures((prevSelectedLectures) => {
      if (!prevSelectedLectures) return null;

      return prevSelectedLectures.map((item) =>
        item.id === lecturer.id
          ? { ...item, activityType: selectedActivityType }
          : item,
      );
    });
  };

  useEffect(() => {
    //handleCreateSerialLectures();
  }, [scheduleType, timeSlot]);

  const handleCreateSerialLectures = async () => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    if (selectedLectures?.some((item) => item.activityType === null)) {
      toast.warn('יש לבחור למרצה את סוג הפעילות המתאים');
      return;
    }

    if (
      !Number.isInteger(lectureAttendanceSessionNumber) ||
      lectureAttendanceSessionNumber < 1 ||
      lectureAttendanceSessionNumber > 3
    ) {
      toast.warn('יש לבחור מספר מפגש נוכחות בין 1 ל-3');
      return;
    }

    if (addBreak) {
      if (
        lectureBreakMinutes === null ||
        lectureBreakMinutes === undefined ||
        !Number.isInteger(lectureBreakMinutes) ||
        lectureBreakMinutes < 0
      ) {
        toast.warn('יש להזין מספר דקות הפסקה תקין (מספר שלם 0 או יותר)');
        return;
      }
    }

    const lecturesIds: LecturerIdWithActivityTypeId[] =
      selectedLectures?.map((item) => ({
        lecturerId: item.id,
        activityTypeId: item.activityType?.lecturersRateType.id,
      })) ?? [];

    const breakMinutesToSend =
      addBreak && lectureBreakMinutes !== null
        ? lectureBreakMinutes
        : undefined;

    onApprove(
      selectedSlots,
      lecturesIds,
      setIsLoadingCreateLectures,
      onHide,
      attendanceRequire,
      lectureAttendanceSessionNumber,
      breakMinutesToSend,
      allowRetroactiveWorkingHoursSupport
        ? professorRetroactiveWorkingHours
        : false,
    );
  };

  // Initialize state with explicit type
  const [selectedSlots, setSelectedSlots] = useState<SelectedSlotsState>({});

  const SUPPORT_MULTIPLE = supportMultiple;

  const handleSlotSelect = (
    lectureNumber: number,
    slot: AvailabilitySlot | null,
  ) => {
    if (!slot?.isAvailable) return;

    setSelectedSlots((prev) => {
      const current = prev[lectureNumber] || [];
      const slotIndex = current.findIndex((s) => s.classId === slot.classId);

      // If found, remove it
      if (slotIndex >= 0) {
        return {
          ...prev,
          [lectureNumber]: current.filter((_, i) => i !== slotIndex),
        };
      }

      // For single selection mode, replace the existing slot
      // For multiple selection mode, add to existing slots
      const newSlots = SUPPORT_MULTIPLE
        ? [...current, { lectureNumber, ...slot }]
        : [{ lectureNumber, ...slot }];

      return { ...prev, [lectureNumber]: newSlots };
    });
  };

  const fieldColumnStyle: React.CSSProperties = {
    flex: 1,
    minWidth: 0,
    maxWidth: '250px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };

  const fieldLabelStyle: React.CSSProperties = {
    fontSize: '14px',
    color: '#4b5563',
  };

  const formRowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'flex-start',
    marginBottom: '16px',
  };

  return (
    <div>
      <Tooltip target=".calendar-vacation-day" />

      <div style={formRowStyle}>
        <div style={fieldColumnStyle}>
          <label style={fieldLabelStyle}>תאריך התחלה</label>
          <Calendar
            id="buttondisplay"
            style={{
              height: '36px',
              width: '100%',
              maxWidth: '250px',
              direction: 'ltr',
            }}
            dateFormat={'dd/mm/yy'}
            inputStyle={{ textAlign: 'right' }}
            value={startDate}
            onChange={handleDateChange}
            dateTemplate={(dateMeta: any) => {
              const d = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
              const vacationInfo = isVacationDate(d);

              if (!vacationInfo.isVacation) {
                return <span>{dateMeta.day}</span>;
              }

              return (
                <span
                  className="calendar-vacation-day"
                  data-pr-tooltip={`חופשה${vacationInfo.title ? `: ${vacationInfo.title}` : ''}`}
                  data-pr-position="top"
                  title={`חופשה${vacationInfo.title ? `: ${vacationInfo.title}` : ''}`}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '6px',
                    backgroundColor: '#FEF3C7',
                    border: '1px solid #F59E0B',
                    color: '#92400E',
                    fontWeight: 700,
                  }}
                >
                  {dateMeta.day}
                </span>
              );
            }}
            showIcon={true}
            iconPos={'right'}
            yearNavigator={true}
            yearRange={`${new Date().getFullYear() - 1}:2027`}
          />
        </div>

        <div style={fieldColumnStyle}>
          <label style={fieldLabelStyle}>בחירת שעות</label>
          <ManualTimeCalendar
            style={{
              height: '36px',
              width: '100%',
              maxWidth: '250px',
              direction: 'ltr',
            }}
            panelStyle={{
              direction: 'ltr',
            }}
            value={startTime}
            inputStyle={{ textAlign: 'right' }}
            onChange={setStartTime}
          />
        </div>

        <div style={fieldColumnStyle}>
          <label style={fieldLabelStyle}>עד</label>
          <ManualTimeCalendar
            style={{
              height: '36px',
              width: '100%',
              direction: 'ltr',
            }}
            panelStyle={{
              direction: 'ltr',
            }}
            value={endTime}
            inputStyle={{ textAlign: 'right' }}
            onChange={setEndTime}
          />
        </div>
      </div>

      <div style={formRowStyle}>
        <div style={fieldColumnStyle}>
          <label style={fieldLabelStyle}>בחירת מרצים</label>
          <MultiSelect
            value={selectedLectures}
            onChange={(e) => setSelectedLectures(e.value)}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '36px',
              width: '100%',
            }}
            options={courseLectures}
            emptyMessage={'לא נמצאו נתונים'}
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
            itemTemplate={(option) => `${option.firstName} ${option.lastName}`}
            placeholder="בחירת מרצה"
            maxSelectedLabels={3}
          />
        </div>

        <div style={fieldColumnStyle}>
          <label style={fieldLabelStyle}>בחירת סוג פעילות</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {lecturerRateById && selectedLectures?.length ? (
              selectedLectures.map((item) => (
                <Dropdown
                  key={item.id}
                  value={item.activityType || null}
                  onChange={(e) =>
                    handleSelectedActivityTypeForLecturer(item, e.value)
                  }
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '36px',
                    width: '100%',
                  }}
                  options={lecturerRateById[item.id]}
                  optionLabel="lecturersRateType.typeRateName"
                  itemTemplate={(option: LecturerRatesVersions) => {
                    return option.lecturersRateType.typeRateName;
                  }}
                  placeholder={
                    selectedLectures.length > 1
                      ? `סוג פעילות ל${item.firstName} ${item.lastName}`
                      : 'בחירת סוג פעילות'
                  }
                />
              ))
            ) : (
              <Dropdown
                value={null}
                options={[]}
                disabled
                placeholder="בחירת סוג פעילות"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '36px',
                  width: '100%',
                }}
              />
            )}
          </div>
        </div>

        <div style={fieldColumnStyle}>
          <label style={fieldLabelStyle}>מספר שיבוצים</label>
          <InputNumber
            style={{ height: '36px', width: '100%', direction: 'ltr' }}
            value={numberOfIterations}
            showButtons
            inputStyle={{ textAlign: 'right' }}
            tooltip={
              editMode
                ? 'במצב עריכה לא ניתן לשנות את מספר המפגשים'
                : 'מספר המפגשים'
            }
            tooltipOptions={{ showOnDisabled: true }}
            onChange={(e) => setNumberOfIterations(e.value ?? 1)}
            disabled={editMode || scheduleType === ScheduleType.EXAM}
          />
        </div>
      </div>

      {scheduleType === ScheduleType.LECTURE && (
        <div style={{ marginBottom: '16px' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              alignItems: 'flex-start',
              marginBottom: '12px',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: '0 0 auto',
              }}
            >
              <label style={fieldLabelStyle}>נוכחות חובה</label>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '36px',
                }}
              >
                <InputSwitch
                  checked={attendanceRequire}
                  onChange={(e) => setAttendanceRequire(e.value)}
                />
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: '0 0 auto',
              }}
            >
              <label style={fieldLabelStyle}>מספר מקטעי הנוכחות</label>
              <Dropdown
                value={lectureAttendanceSessionNumber}
                onChange={(e) => setLectureAttendanceSessionNumber(e.value)}
                options={[
                  { label: '1', value: 1 },
                  { label: '2', value: 2 },
                  { label: '3', value: 3 },
                ]}
                optionLabel="label"
                optionValue="value"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '36px',
                  width: '90px',
                }}
                tooltip={
                  !allowEditAttedancePartialNumber
                    ? 'לא ניתן לשנות את מספר מקטעי הנוכחות'
                    : 'מספר מקטעי הנוכחות'
                }
                tooltipOptions={{ showOnDisabled: true }}
                disabled={
                  !allowEditAttedancePartialNumber || !attendanceRequire
                }
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: '0 0 auto',
              }}
            >
              <label
                htmlFor="add-break-checkbox"
                style={{
                  ...fieldLabelStyle,
                  opacity: allowEditBreakMinutes ? 1 : 0.6,
                }}
              >
                הוספת הפסקה
              </label>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                  alignItems: 'center',
                  height: '36px',
                  flexWrap: 'nowrap',
                }}
              >
                <div style={{ flex: '0 0 auto', display: 'flex' }}>
                  <Checkbox
                    inputId="add-break-checkbox"
                    checked={addBreak}
                    tooltip={
                      allowEditBreakMinutes
                        ? 'לחץ להוספת זמן הפסקה'
                        : 'ניתן לערוך את זמן ההפסקה ממסך ההרצאות'
                    }
                    disabled={!allowEditBreakMinutes}
                    tooltipOptions={{ showOnDisabled: true }}
                    onChange={(e) => {
                      const next = Boolean(e.checked);
                      setAddBreak(next);
                      if (!next) {
                        setLectureBreakMinutes(null);
                      }
                    }}
                  />
                </div>
                <InputNumber
                  value={lectureBreakMinutes}
                  onChange={(e) =>
                    setLectureBreakMinutes(
                      e.value === undefined ? null : e.value,
                    )
                  }
                  min={0}
                  showButtons
                  useGrouping={false}
                  placeholder="דקות"
                  disabled={!addBreak || !allowEditBreakMinutes}
                  inputStyle={{ textAlign: 'right', width: '60px' }}
                  style={{
                    height: '36px',
                    width: '110px',
                    minWidth: '110px',
                    maxWidth: '110px',
                    flex: '0 0 110px',
                    direction: 'ltr',
                  }}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              paddingTop: '4px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <Checkbox
                inputId="professor-retroactive-working-hours-checkbox"
                checked={professorRetroactiveWorkingHours}
                tooltip={
                  allowRetroactiveWorkingHoursSupport
                    ? 'לשינוי רטרואקטיבי של זמני ההרצאה בפועל'
                    : 'ההרצאה טרם התחילה'
                }
                tooltipOptions={{ showOnDisabled: true }}
                disabled={!allowRetroactiveWorkingHoursSupport}
                onChange={(e) =>
                  setProfessorRetroactiveWorkingHours(Boolean(e.checked))
                }
              />
              <label
                htmlFor="professor-retroactive-working-hours-checkbox"
                style={{
                  ...fieldLabelStyle,
                  opacity: allowRetroactiveWorkingHoursSupport ? 1 : 0.6,
                }}
              >
                עדכון שעות עבודה לפי הזמנים המעודכנים
              </label>
            </div>
            <div
              style={{
                fontSize: '12px',
                color: '#9ca3af',
                paddingRight: '28px',
              }}
            >
              עדכון שעות העבודה של המרצה לפי זמני המפגש המעודכנים
            </div>
          </div>
        </div>
      )}

      <TimeSlotContainer
        branchId={branchId}
        startDate={startDate}
        endTime={endTime}
        startTime={startTime}
        iterationNumber={numberOfIterations}
        selectedSlots={selectedSlots}
        handleSlotSelect={handleSlotSelect}
        shouldInitiateSearchSlot={scheduleType === ScheduleType.EXAM}
        editTimeSlot={editTimeSlot}
      />

      <Button
        style={{ height: '30px', marginTop: '8px' }}
        label={'אישור'}
        loading={isLoadingCreateLectures}
        onClick={handleCreateSerialLectures}
      />
    </div>
  );
};
